import $ from "jquery";

window.$ = window.jQuery = $;

$( document ).ready(
	function () {
		const $menuToggle = $( '#menuToggle' );
		const $menuClose  = $( '#menuClose' );
        const $menuItemToggle = $( '.menu-item-button' );

		function togglePrimaryMenu() {
			$( 'body' ).toggleClass( 'menu-open' );
		}

		function closePrimaryMenu() {
			$( 'body' ).removeClass( 'menu-open' );
		}

        $menuItemToggle.on(
            'click touch',
            function (e) {
                $(this).closest('.menu-item-has-children').toggleClass('show')
            }
        )

		$menuToggle.on(
			'click touch',
			function ( e ) {
				togglePrimaryMenu();
			}
		);

		$menuClose.on(
			'click touch',
			function ( e ) {
				closePrimaryMenu();
			}
		);
	}
);
